<template>
    <div>
    <span style="color:black;">
        {{ enchant.attributeName }}
    </span>

    <span v-if="enchant.damageAddition >= 0" style="color: red;font-weight: bolder;">
        {{ enchant.damageAddition }}
    </span>
    <span v-if="enchant.damageAddition < 0" style="color: green;font-weight: bolder;">
        {{ enchant.damageAddition }}
    </span>
</div>
</template>


<script>

export default {
    props:{
        enchant:{
            attributeName: null,
            damageAddition: null,
        }
    }

}
</script>


<style lang="less" scoped>
</style>